import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Typography } from '@sm/wds-react';

export const Menu = ({ title, url }) => {
  return (
    <ListItem key={title} isNavigable navigationTarget={url}>
      <Typography
        variant="sectionTitle"
        color="link"
        className="mobile-menu--type-title"
      >
        {title}
      </Typography>
    </ListItem>
  );
};

Menu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  title: PropTypes.any.isRequired,
  url: PropTypes.node.isRequired,
};

export default Menu;
